<!-- eslint-disable vue/multi-word-component-names -->
<script>
import AppTitleHeader from '@/components/app/TitleHeader.vue';
import AppConversation from '@/components/app/conversation.vue';
import AppBox from '@/components/app/box.vue';
import AppPageContainer from '@/components/app/PageContainer.vue';
// =============================================================
import WorkStartHelper from '@/Helpers/Report/Amar/airAmbulance/workStart.helper';
import AirAmbulanceMixin from '@/Mixins/Report/airAmbulance.mixin';
import SharedMixin from '@/Mixins/Shared';
import SharedHelper from '@/Helpers/Shared';
import Vue from 'vue';
export default {
  name: 'جزییات شروع فعالیت روزانه',
  inject: ['load'],
  mixins: [WorkStartHelper, AirAmbulanceMixin, SharedMixin, SharedHelper],
  components: { AppTitleHeader, AppConversation, AppBox, AppPageContainer },
  mounted() {
    this.mounteLoding();
  },
  computed: {
    phoneActivityId: function () {
      return this.$route.params?.slug;
    },
    timesList: function () {
      return [
        {
          id: 1,
          label: 'تاریخ ثبت گزارش',
          value: this.workStartDetail?.sunRiseTime
            ? Vue.moment(this.workStartDetail?.creationDate)?.format('jYYYY/jMM/jDD')
            : '-',
        },
        {
          id: 1,
          label: 'ساعت طلوع آفتاب',
          value: this.workStartDetail?.sunRiseTime
            ? this.getTime(this.workStartDetail?.sunRiseTime)
            : '-',
        },
        {
          id: 2,
          label: 'ساعت غروب آفتاب',
          value: this.workStartDetail?.sunSetTime
            ? this.getTime(this.workStartDetail?.sunSetTime)
            : '-',
        },
        {
          id: 3,
          label: 'ساعت شروع فعالیت پایگاه هوایی',
          value: this.workStartDetail?.shiftStartTime
            ? this.getTime(this.workStartDetail?.shiftStartTime)
            : '-',
        },
        {
          id: 4,
          label: 'ساعت پایان  فعالیت پایگاه هوایی',
          value: this.workStartDetail?.shiftEndTime
            ? this.getTime(this.workStartDetail?.shiftEndTime)
            : '-',
        },
        {
          id: 5,
          label: 'زمان روشن کردن موتور',
          value: this.workStartDetail?.engineOnTime
            ? this.getTime(this.workStartDetail?.engineOnTime)
            : '-',
        },
        {
          id: 6,
          label: 'زمان خاموش کردن موتور',
          value: this.workStartDetail?.engineOffTime
            ? this.getTime(this.workStartDetail?.engineOffTime)
            : '-',
        },
      ];
    },
    // morningTimesList:function(){
    //   return[

    //   ]
    // },
    weatherConditionItems: function () {
      return [
        {
          id: 1,
          label: 'ارتفاع پایگاه از سطح دریا',
          value: this.workStartDetail?.altitude ? `${this.workStartDetail?.altitude} متر` : '-',
        },
        {
          id: 2,
          label: 'حداقل دما',
          value: this.workStartDetail?.minimumTemperature
            ? `${this.workStartDetail?.minimumTemperature} سانتیگراد`
            : '-',
        },
        {
          id: 3,
          label: 'حداکثر دما',
          value: this.workStartDetail?.maximumTemperature
            ? `${this.workStartDetail?.maximumTemperature} سانتیگراد`
            : '-',
        },
        {
          id: 4,
          label: 'رطوبت',
          value: this.workStartDetail?.humidity ? `${this.workStartDetail?.humidity}%` : '-',
        },
        {
          id: 5,
          label: 'سرعت باد',
          value: this.workStartDetail?.windSpeed
            ? `${this.workStartDetail?.windSpeed} کیلومتر بر ساعت`
            : '-',
        },
        {
          id: 6,
          label: 'جهت وزش باد',
          value: this.workStartDetail?.windSpeed ? `${this.workStartDetail?.windDirection}` : '-',
        },
        {
          id: 7,
          label: 'وضعیت ابر ها',
          value: this.workStartDetail?.windSpeed
            ? `${this.workStartDetail?.cloudStatus === 1
              ? 'صاف'
              : this.workStartDetail?.cloudStatus === 2
                ? 'نیمه ابری'
                : 'ابری'
            }`
            : '-',
        },
        {
          id: 8,
          label: 'احتمال بارندگی',
          value: this.workStartDetail?.rainProbability
            ? `${this.workStartDetail?.rainProbability}%`
            : '-',
        },
        {
          id: 9,
          label: 'عمق دید (visibility)',
          value: this.workStartDetail?.visibility
            ? `${this.workStartDetail?.visibility} متر`
            : '-',
        },
      ];
    },
    mainInformation: function () {
      return [
        {
          id: 1,
          label: 'نوع آمبولانس هوایی',
          value: this.workStartDetail?.airAmbulanceType
            ? this.workStartDetail?.airAmbulanceType === 1
              ? 'هلیکوپتر'
              : this.workStartDetail?.airAmbulanceType === 2
                ? 'هواپیما'
                : 'پهپاد'
            : '-',
        },
        {
          id: 2,
          label: 'نوع هلیکوپتر / هواپیما',
          value: this.workStartDetail?.airAmbulanceTypeDetail ?? '-',
        },
        {
          id: 3,
          label: 'وزن آمبولانس هوایی',
          value: this.workStartDetail?.airAmbulanceWeight ?? '-',
        },
        {
          id: 4,
          label: 'شماره و کد اورژانس هوایی در برج مراقبت فرودگاه',
          value: this.workStartDetail?.codeInWatchtower ?? '-',
        },
        {
          id: 5,
          label: 'شرکت/ ارگان ارائه دهنده خدمات هوایی',
          value: this.workStartDetail?.company ?? '-',
        },
        {
          id: 6,
          label: 'شماره رجیستری',
          value: this.workStartDetail?.registerNumber ?? '-',
        },
        {
          id: 6,
          label: 'تیل نامبر',
          value: this.workStartDetail?.tailNumber ?? '-',
        },
      ];
    },
    flightSpecifications: function () {
      return [
        {
          id: 1,
          label: 'نام و نام خانوادگی خلبان یکم',
          value: this.workStartDetail?.pilot ?? '-',
        },
        {
          id: 2,
          label: 'نام و نام خانوادگی خلبان دوم',
          value: this.workStartDetail?.coPilot ?? '-',
        },
        {
          id: 3,
          label: 'نام و نام خانوادگی مهندس فنی',
          value: this.workStartDetail?.technicalEngineer ?? '-',
        },
        {
          id: 4,
          label: 'نام و نام خانوادگی سایر (با ذکر سمت)',
          value: this.workStartDetail?.otherPersonWithRole ?? '-',
        },
      ];
    },
  },
  methods: {
    mounte: function () {
      this.getPhoneActivityWorkStartDetail(this.phoneActivityId);
    },
    getTime: function (fullDate) {
      return `${fullDate?.split('T').pop()?.split('.').shift()}`;
    },
    backToPage: function () {
      this.$router.back();
    },
  },
};
</script>
<template>
  <app-page-container title="جزییات گزارش شروع فعالیت روزانه">
    <template v-slot:header>
      <v-col cols="3" class="mr-n14 mt-3">
        <v-btn dark class="darkColor" small fab icon rounded @click="backToPage">
          <v-icon color="white" dark>mdi-arrow-right mdi-24px</v-icon>
        </v-btn>
      </v-col>
    </template>
    <template v-slot:body>
      <article class="pa-2 pt-0 body-content">
        <section class="py-3">
          <v-row>
            <v-col cols="12">
              <app-title-header title="زمان ها" />
            </v-col>
            <v-col cols="3" v-for="{ id, label, value } in timesList" :key="id">
              <app-box>
                <app-conversation :question="label" :answer="value" />
              </app-box>
            </v-col>
          </v-row>
          <!-- <v-row>
            <v-col cols="12">
              <app-title-header
                title="ثبت استارت صبحگاهی جهت تست و گرم نمودن موتور"
              />
            </v-col>
            <v-col
              cols="6"
              v-for="({id,label,value}) in morningTimesList"
              :key="id"
            >
              <app-box>
                <app-conversation :question="label" :answer="value" />
              </app-box>
            </v-col>
          </v-row> -->
        </section>
        <section>
          <v-row>
            <v-col cols="12">
              <app-title-header title="شرایط جوی" />
            </v-col>
            <v-col cols="3" v-for="{ id, label, value } in weatherConditionItems" :key="id">
              <app-box>
                <app-conversation :question="label" :answer="value" />
              </app-box>
            </v-col>
          </v-row>
        </section>
        <section class="py-3">
          <v-row>
            <v-col cols="12">
              <app-title-header title="اطلاعات اصلی" />
            </v-col>
            <v-col cols="3" v-for="{ id, label, value } in mainInformation" :key="id">
              <app-box>
                <app-conversation :question="label" :answer="value" />
              </app-box>
            </v-col>
          </v-row>
        </section>
        <section>
          <v-row>
            <v-col cols="12">
              <app-title-header title="مشخصات کروی پروازی" />
            </v-col>
            <v-col cols="6" v-for="{ id, label, value } in flightSpecifications" :key="id">
              <app-box>
                <app-conversation :question="label" :answer="value" />
              </app-box>
            </v-col>
          </v-row>
        </section>
      </article>
    </template>
  </app-page-container>
</template>
<style scoped>
.body-content {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
